import ViewBase from "../../../../framework/core/mvvm/view_base";
import AppData from "../../../public/const/app_data";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import ModelData from "../../../public/model_data";
import bjlRoadmap from "../../../public/bjl_roadmap";
import GameUtil from "../../../../utility/game_util";

const { ccclass, property } = cc._decorator;

@ccclass
export default class BJLRoadMapInfoView extends ViewBase {

    @property(bjlRoadmap)
    myRoadmap:bjlRoadmap = null

    @property(cc.Sprite)
    lastPlayer:cc.Sprite[] = []

    @property(cc.Sprite)
    lastBanker:cc.Sprite[] = []

    @property(SpriteFrameHolder)
    xiaSanLuSpriteHolder:SpriteFrameHolder = null

    @property(cc.Label)
    xianWinLab:cc.Label = null

    @property(cc.Label)
    zhuanWinLab:cc.Label = null

    @property(cc.Label)
    heWinLab:cc.Label = null

    @property(cc.Label)
    xianDuiLab:cc.Label = null

    @property(cc.Label)
    zhuanDuiLab:cc.Label = null

    @property(cc.Label)
    allCountLab:cc.Label = null

    @property(cc.Label)
    bpMin:cc.Label = null

    @property(cc.Label)
    duiziMin:cc.Label = null

    @property(cc.Label)
    heMin:cc.Label = null

    @property(cc.Label)
    bpMax:cc.Label = null

    @property(cc.Label)
    duiziMax:cc.Label = null

    @property(cc.Label)
    heMax:cc.Label = null


    start() {
    
    }

    initShow(intentData){
        this.updateResultCount(intentData)
        let curValue = null
        for(let i =0; i < 3; i++){
            curValue = this.myRoadmap.getForecastState(i, 1)
            if(curValue != null){
                this.lastPlayer[i].spriteFrame =  this.xiaSanLuSpriteHolder.getSpriteFrameByKey(i*2 + curValue) 
            }else{
                this.lastPlayer[i].spriteFrame = null
            }
            
            curValue = this.myRoadmap.getForecastState(i, 2)
            if(curValue != null){
                this.lastBanker[i].spriteFrame =  this.xiaSanLuSpriteHolder.getSpriteFrameByKey(i*2 + curValue) 
            }else{
                this.lastBanker[i].spriteFrame = null
            }
            
        }

        let rule = ModelData.instance.roomInfo.PlayRuleData
        if (rule.game_BetArr.length > 0){
            this.bpMin.string = GameUtil.currencyFormatting(rule.game_BetArr[0], 2, true)
            this.duiziMin.string = GameUtil.currencyFormatting(rule.game_BetArr[0], 2, true)
            this.heMin.string = GameUtil.currencyFormatting(rule.game_BetArr[0], 2, true)
            this.bpMax.string = GameUtil.currencyFormatting(rule.game_Limit, 2, true)
            this.duiziMax.string = GameUtil.currencyFormatting(rule.game_Limit, 2, true)
            this.heMax.string = GameUtil.currencyFormatting(rule.game_Limit, 2, true)
        }

    }


    updateResultCount(resultData){
        let allCount = resultData == null?0 : resultData.length 
        let xianDui = 0
        let zhuanDui = 0
        let countTable = []
        for (let index = 0; index < allCount; index++) {
            const element = resultData[index];
            let resKey = element.result.toString()
            countTable[resKey] = countTable[resKey] == null ? 1 : countTable[resKey] + 1
           if (element.bankerPair){
                zhuanDui += 1
           }
           if (element.playerPair){
                xianDui += 1
            }
        }
        this.allCountLab.string =  allCount.toString()
        this.xianDuiLab.string = xianDui.toString()
        this.zhuanDuiLab.string = zhuanDui.toString()
        this.xianWinLab.string =  (countTable[1] == null ? 0 : countTable[1])
        this.zhuanWinLab.string = (countTable[2] ==null ? 0 : countTable[2])
        this.heWinLab.string = (countTable[3] == null ? 0: countTable[3])
    }
}
